// Google Analytics 4 Configuration
export const GA_MEASUREMENT_ID = import.meta.env.VITE_GOOGLE_ANALYTICS_ID || 'G-PZMLG6DRD3';

// Cookie Consent Configuration
export const COOKIE_CONSENT_KEY = 'china_hospital_cookie_consent';
export const CONSENT_EXPIRY_DAYS = 365; // 12 months
export const CONSENT_VERSION = '1.0.0';

// Default consent settings (analytics granted by default for better insights)
export const DEFAULT_CONSENT = {
  essential: 'granted' as const,  // Always granted for site functionality
  analytics: 'granted' as const,  // Granted by default for better insights
  marketing: 'denied' as const,   // Denied by default (not currently used)
  timestamp: Date.now(),
  version: CONSENT_VERSION,
};

// Event Categories for tracking
export const EVENT_CATEGORIES = {
  PAGE_VIEW: 'page_view',
  FORM: 'form',
  PAYMENT: 'payment',
  HOSPITAL: 'hospital',
  SERVICE: 'service',
  CONSENT: 'consent',
  ERROR: 'error',
} as const;

// Form Types
export const FORM_TYPES = {
  CONSULTATION: 'consultation',
  BOOKING: 'booking',
  CONTACT: 'contact',
} as const;

// Payment Types
export const PAYMENT_TYPES = {
  CONSULTATION: 'consultation',
  BOOKING: 'booking',
} as const;

// Hospital Interaction Types
export const HOSPITAL_INTERACTIONS = {
  VIEW: 'view',
  CLICK: 'click',
  SEARCH: 'search',
  FILTER: 'filter',
} as const;

// Debug mode for development
export const IS_DEV = import.meta.env.DEV;
